import { useQuery } from 'react-query';

import { logError } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import {
  COUNTRY_CODES,
  HANDLING_MODES,
} from '@savgroup-front-common/constants';

import {
  getClaimGroupTransportPlanQuery,
  TRANSPORT_METHOD_TYPE,
  TransportMethodType,
  TransportPlan,
} from '../getClaimGroupTransportPlanQuery';

export const GET_CLAIM_GROUP_TRANSPORT_PLAN_QUERY_KEY =
  'getClaimGroupTransportPlanQuery';

export const homeMethods: TransportMethodType[] = [
  TRANSPORT_METHOD_TYPE.OnSiteCollection,
  TRANSPORT_METHOD_TYPE.HomePickup,
  TRANSPORT_METHOD_TYPE.HomePickupProvidedBySeller,
  TRANSPORT_METHOD_TYPE.LabelProvidedBySeller,
  TRANSPORT_METHOD_TYPE.HomeDelivery,
  TRANSPORT_METHOD_TYPE.BulkyHomeDelivery,
  TRANSPORT_METHOD_TYPE.HomeIntervention,
];
export const pickupMethods: TransportMethodType[] = [
  TRANSPORT_METHOD_TYPE.RelayPointDeposit,
  TRANSPORT_METHOD_TYPE.PickUpRelayPointDelivery,
  TRANSPORT_METHOD_TYPE.DropAtStoreDeposit,
  TRANSPORT_METHOD_TYPE.PickUpStoreDelivery,
];

export const immediateDropAtStoreMethods: TransportMethodType[] = [
  TRANSPORT_METHOD_TYPE.ImmediateDropAtStoreDeposit,
];

export const useGetClaimGroupTransportPlanQuery = ({
  claimGroupId,
  countryCode,
  zipCode,
  isForceFreeHandling = false,
  onSuccess,
  handlingMode,
}: {
  claimGroupId?: string;
  countryCode?: COUNTRY_CODES;
  zipCode?: string;
  isForceFreeHandling?: boolean;
  onSuccess?: (data: TransportPlan[]) => void;
  handlingMode?: HANDLING_MODES;
}) => {
  const { data: transportPlans, isLoading } = useQuery(
    [
      GET_CLAIM_GROUP_TRANSPORT_PLAN_QUERY_KEY,
      {
        claimGroupId,
        countryCode,
        zipCode,
        isForceFreeHandling,
        handlingMode,
      },
    ],
    async () => {
      if (!claimGroupId) {
        return [];
      }

      const response = await getClaimGroupTransportPlanQuery({
        claimGroupId,
        countryCode,
        zipCode,
      });

      if (response.failure) {
        logError(response.errors);

        return [];
      }

      return response.value.map((transportPlan) => {
        if (!isForceFreeHandling) {
          return transportPlan;
        }

        return {
          ...transportPlan,
          priceWithTax: 0,
          isDeductible: false,
        };
      });
    },
    {
      suspense: false,
      staleTime: 0,
      onSuccess,
    },
  );

  return {
    transportPlans,
    isLoading,
  };
};
